// extracted by mini-css-extract-plugin
module.exports = {"PanelHeader":"PanelHeader_PanelHeader__3aZWx"};